import React, {useEffect} from "react";
import Playground from "./Playground";
import {
    Box,
    createTheme,
    CssBaseline,
    Grid,
    ThemeProvider,
    Typography
} from "@mui/material";
import {useAuth0} from "@auth0/auth0-react";
import {GradientButton, GradientProgressBar, GradientText} from "./components/GradientComponents";
import "./components/components.css"
import MediumSimpleLockIcon from "./icons/MediumSimpleLockIcon";
import MediumBookOpenIcon from "./icons/MediumBookOpenIcon";
import ArrowLeft from "./icons/ArrowLeft";
import Paper from "@mui/material/Paper/Paper";
import {SymblLogoGradient} from "./icons/SymblLogo";
import BackgroundCircleForLogo from "./icons/BackgroundCircleForLogo";

const theme = createTheme({
    typography: {
        fontFamily: [
            'Work Sans',
            'Roboto',
            'Helvetica',
            'Arial',
            'sans-serif',
            '"Helvetica Neue"',
            '-apple-system',
            'BlinkMacSystemFont',
            '"Apple Color Emoji"',
            '"Segoe UI Emoji"',
            '"Segoe UI Symbol"',
        ].join(',')
    },
    components: {
        MuiIconButton: {
            styleOverrides: {
                root: {
                    '&:hover': {
                        backgroundColor: '#FEF7F8',
                    }
                }
            }
        }
    }
})

function App() {
    const {loginWithRedirect, isAuthenticated, isLoading, error, logout, user} = useAuth0();

    useEffect(() => {
        // if (error) {
        //     console.error(error);
        // }
        if (!error && !isAuthenticated && !isLoading) {
            loginWithRedirect();
        }

        console.log("!!!!!!!!!!! isAuthenticated ", isAuthenticated, ' isLoading ', isLoading, ' error ', error);
    }, [isAuthenticated, isLoading, error]);

    useEffect(() => {
        // @ts-ignore
        if (window.pendo && user) {
            // @ts-ignore
            const pendo = window.pendo;
            pendo.initialize({
                visitor: {
                    id: user.sub,
                    email: user.email,
                    full_name: user.name
                },
                account: {
                    id: user.sub,
                    name: user.name,
                }
            });
        }
    }, [user]);

    return (
        <div>
            <ThemeProvider theme={theme}>
                <CssBaseline/>
                {(error) && (
                    <Paper style={{
                        alignSelf: 'center',
                        borderRadius: 8,
                        position: 'absolute',
                        boxShadow: '0px 12px 16px -4px #0F1A2A14',
                        top: '50%',
                        left: '50%',
                        transform: 'translate(-50%, -50%)',
                        overflow: 'auto',
                        width: '80%',
                        maxWidth: 900
                    }}>
                        <Box sx={{padding: 8, paddingTop: 2}}
                             display={"flex"}
                             justifyContent={"center"}
                             alignItems={"center"}
                             flexDirection={"column"}
                        >
                            <SymblLogoGradient size={"medium"} style={{
                                position: 'absolute',
                                top: 86
                            }}/>
                            <BackgroundCircleForLogo/>
                            {
                                error.message.includes("do not have access") ? (
                                    <Typography variant={"body2"} align={"center"}
                                                sx={{mb: 2, mt: -2}}>Thank you for your interest in Nebula. The model is
                                        currently available for limited set of users. Please request access to express
                                        your interest, and we'll get in touch with you.
                                    </Typography>) : (
                                    <Typography variant={"body2"} align={"center"}
                                                sx={{mt: 4, mb: 2}}>{error.message}</Typography>
                                )
                            }
                            < Typography variant={"body2"} align={"center"}>If you have already submitted request for
                                access, thanks for being patient; we'll reach out to you as we go through the users who
                                applied before you.</Typography>

                            <Grid container spacing={2} sx={{mt: 2}}>
                                <Grid item xs={4}>
                                    <GradientButton
                                        style={{
                                            width: '100%',
                                            maxWidth: 236
                                        }}
                                        onClick={() => logout()}
                                        startIcon={<ArrowLeft/>}
                                    >
                                        <GradientText variant={"body2"}>Back to
                                            Login</GradientText>
                                    </GradientButton>
                                </Grid>
                                <Grid item xs={4}>
                                    <a href={"https://docs.symbl.ai/docs/model-api"} target="_blank" rel="noreferrer">
                                        <GradientButton
                                            style={{
                                                width: '100%',
                                                maxWidth: 236
                                            }}
                                            startIcon={<MediumBookOpenIcon/>}>
                                            <GradientText variant={"body2"}>Learn
                                                more about Nebula</GradientText>
                                        </GradientButton>
                                    </a>
                                </Grid>
                                <Grid item xs={4}>
                                    <a href={"https://info.symbl.ai/Nebula_Private_Beta.html"} target="_blank"
                                       rel="noreferrer">
                                        <GradientButton
                                            style={{
                                                width: '100%',
                                                maxWidth: 236
                                            }}
                                            gradientBackground
                                            startIcon={<MediumSimpleLockIcon/>}
                                        >
                                            <Typography variant={"body2"}>Request
                                                Access</Typography>
                                        </GradientButton>
                                    </a>
                                </Grid>

                            </Grid>
                        </Box>
                    </Paper>

                )}
                {isLoading && (<GradientProgressBar/>)}
                {isAuthenticated && !error ? <Playground/> : null}
            </ThemeProvider>
        </div>
    );
}

export default App;
